<div class="spinner-overlay" *ngIf="isLoading">
  <div class="spinner"></div>
</div>
